import axios from "axios";
import { publish } from "./refreshBus";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const memberToken = localStorage.getItem("samrudhi_member_token");
  const adminToken = localStorage.getItem("samrudhi_admin_token");
  const employeeToken = localStorage.getItem("samrudhi_employee_token");
  if (config.url?.startsWith("/admin") && (adminToken || employeeToken)) {
    config.headers.Authorization = `Bearer ${adminToken || employeeToken}`;
  } else if (memberToken) {
    config.headers.Authorization = `Bearer ${memberToken}`;
  }
  return config;
});

// 2026-09-14 - live data refresh: after ANY successful mutating call (POST/PUT/PATCH/
// DELETE) on either side, automatically publish scopes derived from the URL so listening
// components (wallet balance, notifications, scratch card, withdrawals, KYC, team, booster,
// bonus, etc.) can refetch themselves - no manual page reload needed, and zero new polling
// added (this rides on calls that already happen). See lib/refreshBus.js.
function scopesForUrl(url) {
  const path = (url || "").split("?")[0].replace(/^\/+/, "");
  const segments = path.split("/").filter(Boolean);
  // drop id-like segments (ObjectIds, numeric ids, uuids) - not meaningful scope names
  const named = segments.filter((s) => !/^[0-9a-f]{20,24}$/i.test(s) && !/^[0-9-]+$/.test(s));
  const scopes = new Set(named);
  if (segments[0] === "admin") {
    scopes.add("admin");
  } else {
    scopes.add("member");
    scopes.add("notifications");
  }
  return Array.from(scopes);
}

api.interceptors.response.use((response) => {
  const method = response.config?.method?.toLowerCase();
  if (method && method !== "get") {
    publish(scopesForUrl(response.config.url));
  }
  return response;
});

export function getApiErrorMessage(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (detail?.message) {
    return [detail.message, ...(detail.errors || [])].join(" ");
  }
  return "Something went wrong. Please try again.";
}
